import { render, staticRenderFns } from "./BasicFooter.vue?vue&type=template&id=31649ecb&scoped=true"
import script from "./BasicFooter.vue?vue&type=script&lang=ts"
export * from "./BasicFooter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31649ecb",
  null
  
)

export default component.exports